import { useParams } from 'react-router-dom';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { getStaticExternalPagePermission } from './useStaticExternalPageGroups';
import { StaticExternalPageContent } from './StaticExternalPageContent';

/**
 * Route-level guard for /external-pages/:pageId. The sidebar only shows a
 * link when usePermission() (see ExternalPageSubmenuGroup) says the page is
 * allowed, but that's a UI-only filter -- it doesn't stop someone who already
 * has the URL from navigating straight to it. This mirrors the static-content
 * plugin's route guard (see staticContentPlugin.tsx) so the same permission
 * used to hide the sidebar entry also blocks direct navigation.
 */
export function RequireExternalPageAccess() {
  const { pageId } = useParams<{ pageId: string }>();

  return (
    <RequirePermission permission={getStaticExternalPagePermission(pageId as string)}>
      <StaticExternalPageContent />
    </RequirePermission>
  );
}
